package app.nestbridge.feature.designcatalog.ui

import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.designcatalog.DesignCatalog
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import app.nestbridge.feature.designcatalog.screen.DesignCatalogEvent
import app.nestbridge.feature.designcatalog.screen.DesignCatalogScreen
import app.nestbridge.feature.designcatalog.screen.DesignCatalogState
import app.nestbridge.ui.theme.NestBridgeTheme
import com.slack.circuit.codegen.annotations.CircuitInject
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@OptIn(ExperimentalMaterial3Api::class)
@CircuitInject(
    screen = DesignCatalogScreen::class,
    scope = AppScope::class,
)
@Composable
fun DesignCatalogUi(
    state: DesignCatalogState,
    modifier: Modifier = Modifier,
) {
    Scaffold(
        modifier = modifier,
        topBar = {
            TopAppBar(
                title = {
                    Text(
                        text = "Design Catalog",
                        style = CoreTypography.bodySecondary,
                        color = CoreTheme.colors.textPrimary,
                    )
                },
                navigationIcon = {
                    IconButton(
                        onClick = {
                            state.eventSink(DesignCatalogEvent.BackClicked)
                        },
                    ) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "Back",
                            tint = CoreTheme.colors.onBackground,
                        )
                    }
                },
            )
        },
    ) { padding ->
        DesignCatalog(
            modifier = modifier.padding(padding),
        )
    }
}

@Preview
@Composable
fun DesignCatalogPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        DesignCatalogUi(DesignCatalogState(
            eventSink = {},
        ))
    }
}